import { Link } from 'react-router-dom';

const items = [
  { icon: 'ri-file-paper-2-line', title: 'Flyers de Alto Impacto', desc: 'Diseños llamativos que capturan la atención de tu audiencia.' },
  { icon: 'ri-contacts-book-line', title: 'Tarjetas de Presentación', desc: 'Primera impresión profesional que deja huella en tus clientes.' },
  { icon: 'ri-megaphone-line', title: 'Material Publicitario', desc: 'Banners, posters y material de branding para tu negocio.' },
  { icon: 'ri-car-line', title: 'Microperforados', desc: 'Para vehículos, vitrinas y espacios comerciales con visibilidad total.' },
];

const CommercialSection = () => {
  return (
    <section className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative rounded-3xl overflow-hidden h-[360px] md:h-[480px]">
            <img
              src="https://public.readdy.ai/ai/img_res/4fd23da2e90dae862c2a634240a51ded.jpg"
              alt="Impresión comercial Printven LLC"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/40 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <div className="bg-white/95 rounded-xl p-4 flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-lg">
                  <i className="ri-printer-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-[#0A1628] font-bold text-sm">Impresión Comercial</div>
                  <div className="text-[#6C757D] text-xs">Calidad profesional garantizada</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest">Soluciones Comerciales</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#0A1628] mt-3 mb-5 leading-tight">
              Impulsa tu negocio con material de impresión profesional
            </h2>
            <p className="text-[#6C757D] text-base leading-relaxed mb-8">
              Desde tarjetas de presentación hasta microperforados para vehículos, ofrecemos soluciones completas de impresión comercial que fortalecen la imagen de tu marca.
            </p>

            <ul className="flex flex-col gap-5 mb-10">
              {items.map((item) => (
                <li key={item.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-[#FF6B35] text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-[#0A1628] font-semibold text-sm">{item.title}</div>
                    <div className="text-[#6C757D] text-sm mt-0.5">{item.desc}</div>
                  </div>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <Link
                to="/servicios"
                className="inline-flex items-center justify-center gap-2 bg-[#FF6B35] text-white font-bold px-6 md:px-7 py-3.5 md:py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#e85a24] transition-colors text-sm md:text-base"
              >
                Solicitar Cotización Comercial
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="https://wa.me/17542034748"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#0A1628] text-[#0A1628] font-bold px-6 md:px-7 py-3.5 md:py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#0A1628] hover:text-white transition-all text-sm md:text-base"
              >
                <i className="ri-whatsapp-line"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommercialSection;
